import config from '../../config/api'
export const redirectToSEL = (companyId) => {
  const accessToken = window.localStorage.getItem('AccessToken');
  const refreshToken =  window.localStorage.getItem('RefreshToken');
  window.location = `${config.selUrl}login?at=${accessToken}&rt=${refreshToken}&cr=${companyId}`;
};
